<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-find-replace`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 6a1 1 0 00-1 1v2a1 1 0 001 1h38a1 1 0 001-1V7a1 1 0 00-1-1H5zm30.983 30.81A10.954 10.954 0 0131 38c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11c0 2.692-.967 5.158-2.572 7.07l3.92 4.671a1 1 0 01-.124 1.409l-1.838 1.543a1 1 0 01-1.409-.123l-3.994-4.76zM31 34a7 7 0 100-14 7 7 0 000 14zM4 39a1 1 0 011-1h11a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2zm1-17a1 1 0 00-1 1v2a1 1 0 001 1h11a1 1 0 001-1v-2a1 1 0 00-1-1H5z"/></svg>
</template>
<script>

export default {
  name: 'IconFindReplace',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
